module.exports = __webpack_public_path__ + "static/img/作品展示1.152ea62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/作品展示1.jpg
// module id = 7lMh
// module chunks = 2